import React, { useCallback, useEffect } from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { ImagineSection } from './components/ImagineSection';
import { ComparisonSection } from './components/ComparisonSection';
import { IdentifySection } from './components/IdentifySection';
import { TomosSection } from './components/TomosSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { AuthorSection } from './components/AuthorSection';
import { FaqSection } from './components/FaqSection';
import { FinalCta } from './components/FinalCta';
import { FloatingCta } from './components/FloatingCta';
const PIXEL_ID = '4622525324645553';
const CHECKOUT_URL = 'https://preguntas.impultienda.ar';
type PixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  loaded?: boolean;
  version?: string;
};
declare global {
  interface Window {
    fbq?: PixelFunction;
    _fbq?: PixelFunction;
  }
}
function loadMetaPixel() {
  if (window.fbq) return;
  const fbq = ((...args: unknown[]) => {
    if (fbq.callMethod) {
      fbq.callMethod(...args);
    } else {
      fbq.queue?.push(args);
    }
  }) as PixelFunction;
  fbq.queue = [];
  fbq.loaded = true;
  fbq.version = '2.0';
  window.fbq = fbq;
  window._fbq = fbq;
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  script.onerror = () => {
    // Tracking must never block the landing page when an ad blocker or network blocks Meta.
  };
  document.head.appendChild(script);
  fbq('init', PIXEL_ID);
  fbq('track', 'PageView');
}
export function App() {
  useEffect(() => {
    loadMetaPixel();
  }, []);
  const handleCta = useCallback(() => {
    window.fbq?.('track', 'InitiateCheckout');
    if (CHECKOUT_URL.startsWith('#')) {
      document.querySelector(CHECKOUT_URL)?.scrollIntoView({
        behavior: 'smooth'
      });
    } else {
      window.location.href = CHECKOUT_URL;
    }
  }, []);
  return <main className="w-full bg-[#faf6fb]" data-id="element-0" data-mp="d45ti3frgbmk">
      <Hero onCta={handleCta} data-id="element-1" data-mp="85uihpdqbv2r" />
      <ProblemSection data-id="element-2" data-mp="86mev2f5hwu3" />
      <ImagineSection data-id="element-3" data-mp="864d5q9pyqes" />
      <ComparisonSection data-id="element-4" data-mp="83qhbf77ta66" />
      <IdentifySection data-id="element-5" data-mp="3gkv0trn63pda" />
      <TomosSection data-id="element-6" data-mp="3gmfuzg5kl6am" />
      <BonusSection data-id="element-7" data-mp="3glnze5bz38kc" />
      <PricingSection onCta={handleCta} data-id="element-8" data-mp="3gj1s86szuv2n" />
      <GuaranteeSection data-id="element-9" data-mp="3bn30c98giuxh" />
      <TestimonialsSection data-id="element-10" data-mp="3bnuudfmeokln" />
      <AuthorSection data-id="element-11" data-mp="3bkgq21u6m1bk" />
      <FaqSection data-id="element-12" data-mp="3qaxu7sy7b5c5" />
      <FinalCta onCta={handleCta} data-id="element-13" data-mp="3qbfztg6r6vwq" />

      <FloatingCta triggerId="hero-cta" onClick={handleCta} data-id="element-14" data-mp="3qcin7e4vag7w" />
    </main>;
}